"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useClickScroll = void 0;

var _react = require("react");

var useClickScroll = function useClickScroll(_ref) {
  var trackRef = _ref.trackRef,
      thumbRef = _ref.thumbRef,
      viewport = _ref.viewport,
      scrollWidth = _ref.scrollWidth,
      trackWidth = _ref.trackWidth;
  (0, _react.useEffect)(function () {
    if (!viewport || !(trackRef !== null && trackRef !== void 0 && trackRef.current) || !(thumbRef !== null && thumbRef !== void 0 && thumbRef.current)) return;
    var thumb = thumbRef.current;
    var track = trackRef.current;

    var handleMouseDown = function handleMouseDown(event) {
      var x = // Where you clicked
      event.pageX - // Offset by where the track sits on the page
      track.getBoundingClientRect().left - // Then center the thumb
      thumb.clientWidth / 2;
      viewport.scrollLeft = x * scrollWidth / trackWidth;
    };

    track.addEventListener("mousedown", handleMouseDown);
    return function () {
      track.removeEventListener("mousedown", handleMouseDown);
    };
  }, [scrollWidth, thumbRef, trackRef, trackWidth, viewport]);
};

exports.useClickScroll = useClickScroll;